import SidebarCollapse from "@builder/components/app/SidebarCollapse";
import { EditableProps } from "@builder/components/editable/editableProps";
import Background from "../Background";
import Borders from "../Borders";
import Size from "../Size";
import Spacing from "../Spacing";
import Typography from "../Typography";

const StyleFullButton = ({ parent, path, title }: EditableProps) => {
    return (
        <SidebarCollapse title={title || "Style Button"} parent={parent}>
            <Size noWrapper path={path} />
            <Background noWrapper path={path} />
            <Borders noWrapper path={path} />
            <Spacing noWrapper path={path} excluded={["margin"]} />
            <Typography noWrapper path={path} />
        </SidebarCollapse>
    );
};

export default StyleFullButton;
